import { Link } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { Container, Overline, Reveal } from "@/lib/ui";
import { IMAGES } from "@/data/site";

const roles = [
  { title: "Regional Property Manager", type: "Operations", loc: "Multiple Markets" },
  { title: "Asset Manager", type: "Asset Management", loc: "Corporate" },
  { title: "Leasing Consultant", type: "Leasing & Marketing", loc: "On-Site" },
  { title: "Maintenance Technician", type: "Maintenance Operations", loc: "On-Site" },
  { title: "Financial Analyst", type: "Reporting & Analytics", loc: "Corporate" },
  { title: "Guest Experience Lead", type: "Hospitality", loc: "On-Site" },
];

export default function Careers() {
  return (
    <>
      <PageHero
        id="careers"
        overline="Careers"
        title="Build a career in institutional real estate operations."
        lead="We hire operators who take ownership. Join a team where property-level execution and investment strategy come together."
        image={IMAGES.team}
      />

      <section className="py-24 md:py-32 bg-[#F7F7F5]">
        <Container>
          <Overline>Open Roles</Overline>
          <div className="mt-8 border-t border-[#E5E5DF]">
            {roles.map((r, i) => (
              <Reveal key={r.title} delay={i * 0.04}>
                <div className="grid grid-cols-12 items-center gap-4 border-b border-[#E5E5DF] py-6 group">
                  <h3 className="col-span-12 md:col-span-6 font-display text-xl md:text-2xl text-[#121A16]">{r.title}</h3>
                  <span className="col-span-6 md:col-span-3 text-sm text-[#5C6660]">{r.type}</span>
                  <span className="col-span-4 md:col-span-2 text-sm text-[#5C6660]">{r.loc}</span>
                  <Link to="/contact" className="col-span-2 md:col-span-1 justify-self-end text-sm font-medium text-[#1B3B2B] hover:underline">Apply</Link>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="mt-10 text-[#5C6660] max-w-2xl">
            Don't see the right role? We're always interested in talented operators.{" "}
            <Link to="/contact" className="text-[#1B3B2B] font-medium">Get in touch</Link> to start a conversation.
          </p>
        </Container>
      </section>
    </>
  );
}
